export const LOGIN_POST_REQUESTING = 'LOGIN_POST_REQUESTING';
export const LOGIN_POST_SUCCESS = 'LOGIN_POST_SUCCESS';
export const LOGIN_POST_ERROR = 'LOGIN_POST_ERROR';